import { Button } from '@paid-ui/components/button';
import { EmailInput } from '@paid-ui/components/email-input';
import { Form, FormControl, FormField, FormHelper, FormItem } from '@paid-ui/components/form';
import { Link } from '@paid-ui/components/link';
import { Logo } from '@paid-ui/components/logo';

import { useForgotPassword, useForgotPasswordForm } from './hooks';

export const ForgotPasswordForm = () => {
  const form = useForgotPasswordForm();
  const { mutate, isLoading: isPending } = useForgotPassword();

  const account = form.watch('account');
  const isValid = Boolean(account) && !form.getFieldState('account').invalid;

  const handleSubmit = form.handleSubmit((values) => {
    mutate(values);
  });

  return (
    <Form {...form}>
      <form
        id="forgotPasswordForm"
        onSubmit={handleSubmit}
        className="relative flex h-full w-full flex-1 flex-col space-y-12"
      >
        <header className="shrink-0">
          <div className="space-y-9">
            <Logo height={33} className="m-auto" />
            <div className="space-y-3 text-center">
              <h2 className="text-[28px] font-semibold leading-[31px]">Forgot your password.</h2>
            </div>
          </div>
        </header>
        <div className="flex-1 space-y-3.5">
          <FormField
            name="account"
            control={form.control}
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <EmailInput
                    {...field}
                    placeholder="Enter your email"
                    disabled={isPending}
                    className="text-center"
                  />
                </FormControl>
                <FormHelper />
              </FormItem>
            )}
          />
          <Button type="submit" size="xl" variant="solid" disabled={!isValid} loading={isPending}>
            {isPending ? 'Sending email...' : 'Send reset email'}
          </Button>
        </div>
        <footer className="shrink-0 space-y-3.5 text-center text-base">
          Got password back?{' '}
          <Link className="font-semibold" href="/signin">
            Sign in
          </Link>
          .
        </footer>
      </form>
    </Form>
  );
};
